<template>
	<!-- Select time slot -->
	<div
		class="full-modal booking-modal modal-time-slots hidden-md hidden-lg"
		v-bind:class="{ 'modal-show': ui.modalState == 4 }"
	>
		<div class="modal-title padding-bottom-xs-1">
			<div class="col-xs-12">
				<h3
					class="
						margin-bottom-xs-1
						padding-bottom-xs-1
						menu-item-lined
						no-line-top
						capitalize
					"
				>
					Din bokning
				</h3>
				<a
					href="#"
					class="modal-close link-close-right"
					@click.prevent="handleModalClose()"
				></a>
			</div>
		</div>

		<div class="padding-top-xs-5 margin-top-xs-5 modal-time-slots-body">
			<div
				class="
					modal-body
					padding-left-xs-0 padding-right-xs-0
					margin-top-xs-0
				"
			>
				<PatientForm />
			</div>
		</div>
	</div>
</template>


<script>
import { mapState, mapGetters, mapActions } from "vuex";
import PatientForm from "./PatientForm.vue";

export default {
	components: {
		PatientForm,
	},
	computed: {
		...mapState([
			"activityGroups",
			"activities",
			"providers",
			"selectedSlot",
			"dates",
			"ui",
			"booking",
			"patient",
		]),
		...mapGetters([
			"dateIsInThePast",
			"activityIsCampaign",
			"formatProviderName",
			"selectedSlotFormated",
			"formIsValid",
			"noAvailableTimesForWeek",
		]),
	},
	methods: {
		...mapActions([
			"setActivityGroup",
			"setActivity",
			"setupActiveDates",
			"setSelectedSlot",
			"setProvider",
			"getRealWeekday",
			"setModalState",
			"handleSwipe",
			"prepareNewBooking",
			"shouldDeselectTimeslot",
			"cancelBankIDOrder",
		]),
		handleModalClose() {
			if (this.booking.completed) {
				this.prepareNewBooking();
			} else {
				/* If a BankID sign is currently in progress, cancel it when the user closes the modal */
				if (this.ui.loading.doingBooking) {
					this.cancelBankIDOrder();
				}
				this.setModalState(3);
			}
		},
	},
};
</script>